import React, {Component} from "react";

import {
    Image,
    Platform,
    StyleSheet,
    TouchableHighlight, TouchableOpacity, ActivityIndicator, Alert, PermissionsAndroid,
    FlatList,

    KeyboardAvoidingView,
    View
} from "react-native";


import HMTextView from "../customviews/HMTextView";

import i18n from './../I18n/i18n.js';
import * as Colors from "../tools/Colors";
import {moderateScale} from "../tools/Scaling";

import {connect} from "react-redux";

import {colorPrimary} from "../tools/Colors";

let content = null;

//let chechVersion = false;
//let DataSplashScreen = null;
//let chechVersion_force = null;

let time = 3000
//import DatePicker from 'react-native-jalaali-date-picker'
import DatePicker from './PersianDatePicker'
import moment from "moment-jalaali";
//import fa from "moment/src/locale/fa";
import HMIcon from "./HMIcon";
import HMModal from "./modal/HMModal";

moment.locale("fa");
moment.loadPersian();
// moment.locale("fa");
// moment.loadPersian();
// moment.locale(i18n.locale === 'en' ? 'en' : "fa", i18n.locale === 'en' ? en : fa);
// i18n.locale === 'fa' ? moment.loadPersian() : null;

class HMDatePicker extends Component {


    constructor(props) {
        super(props);
        content = this;
        this.state = {
            showDialog: true,

            selectedDateTo: 0,

            selectedDateFrom: 0,
            indexSelectType: 0,
            dateModal: 0,
            NameDate:props.NameDate

        }

        // try {
        //     this.checkSatusWifi()
        //
        // }
        // catch (e) {
        //     alert("kikkkk")
        // }


    }


    render() {
        const {selfStyle, titlee, textt, onPressOk, onPressCancel, onPressOK, numberOfLines, data,isVisible,cancel,} = this.props;
      ///  let date = this.state[`finalDate` + this.state.NameDate] ? moment(this.state[`finalDate` + this.state.NameDate], 'jYYYY/jM/jD').format('YYYY-MM-DD') : null
        let date =null

        return (

            //  this.state.showDialog && !(this.props.wifiIsEnabled && this.props.wifiConnectionStatus) ?
            <HMModal
                // style={{backgroundColor: Colors.transparent}}
                // position={"center"}
                // ref={"modal"}
                // backdropPressToClose={true}
                // coverScreen={true}
                // swipeToClose={true}
                // backButtonClose={true}
                // isOpen={this.state.visibleModal}
                // onClosed={() => this.setState({visibleModal: false})}

                isVisible={isVisible}
                //visible={this.state.visibleModal}
                backdropColor={Colors.gray}
                backdropOpacity={0.8}
                animationIn="zoomInDown"
                animationOut="zoomOutUp"
                animationInTiming={600}
                animationOutTiming={600}
                backdropTransitionInTiming={600}
                backdropTransitionOutTiming={600}
                //style={{height: '60%'}}
                onBackdropPress={cancel}
                onBackButtonPress={cancel}

                animationType="slide"
            >


            <View style={{backgroundColor: "#fdfdfd"}}>

                        <DatePicker
                            //   ref={view => this._onRef('ref_DatePicker', view)}
                            //   defDateString={content.state[`finalDate`+content.state.NameDate]?content.state[`finalDate`+content.state.NameDate]:null}
                            defDateString={date}
                            // defDate={null}
                            showTitleDate={true}
                            dateBoxStyle={{height: moderateScale(50)}}
                            onChangeDate={(date) => {
                                content.onDayPress(date)
                            }}
                            // onChangeDate={(date)=>{
                            //
                            // }}
                        />
                        {/*<Calendar*/}
                        {/*onDayPress={this.onDayPress}*/}
                        {/*jalali={true}*/}
                        {/*firstDay={6}*/}
                        {/*style={styles.calendar}*/}
                        {/*hideExtraDays*/}
                        {/*markedDates={{*/}
                        {/*[this.state.Date]: {*/}
                        {/*selected: true,*/}
                        {/*disableTouchEvent: true,*/}
                        {/*selectedDotColor: 'orange'*/}
                        {/*}*/}
                        {/*}}*/}
                        {/*/>*/}
                        {/*<Agenda*/}
                        {/*jalali={true}*/}
                        {/*firstDay={6}*/}
                        {/*style={styles.calendar}*/}
                        {/*hideExtraDays*/}
                        {/*markedDates={{*/}
                        {/*[this.state.Date]: {*/}
                        {/*selected: true,*/}
                        {/*disableTouchEvent: true,*/}
                        {/*selectedDotColor: 'orange'*/}
                        {/*}*/}
                        {/*}}*/}
                        {/*/>*/}
                        <View style={{
                            flexDirection: 'row',
                            marginVertical: moderateScale(10),
                            justifyContent: 'space-between',
                            paddingHorizontal: moderateScale(4)
                        }}>
                            <TouchableOpacity style={{
                                backgroundColor: Colors.green,
                                width: "32%",
                                height: moderateScale(40),
                                alignItems: "center",
                                justifyContent: "center",
                                // borderRadius:moderateScale(2)
                            }}

                                              onPress={() => {
                                                  this.onPressOkDate()
                                              }}

                            >
                                <View
                                    style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>
                                    <HMTextView type={"bold"} text={"تایید"} style={{
                                        color: "white",
                                        fontSize: moderateScale(16),
                                        // marginEnd: moderateScale(10)
                                    }}/>

                                </View>
                            </TouchableOpacity>
                            <TouchableOpacity style={{
                                backgroundColor: Colors.red,
                                width: "32%",
                                height: moderateScale(40),
                                alignItems: "center",
                                justifyContent: "center",
                                // borderRadius:moderateScale(2)
                            }}
                                              onPress={() => {
                                                  this.onPressCancelDate(this.state.NameDate)
                                              }}

                            >
                                <View
                                    style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>
                                    <HMTextView type={"bold"} text={"لغو"} style={{
                                        color: "white",
                                        fontSize: moderateScale(16),
                                        //marginEnd: moderateScale(10)
                                    }}/>

                                </View>
                            </TouchableOpacity>

                            <TouchableOpacity style={{
                                backgroundColor: Colors.colorDark,
                                width: "32%",
                                height: moderateScale(40),
                                alignItems: "center",
                                justifyContent: "center",
                                // borderRadius:moderateScale(2)
                            }}
                                              onPress={cancel}

                            >
                                <View
                                    style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>
                                    <HMTextView type={"bold"} text={i18n.t('constant.Back')} style={{
                                        color: "white",
                                        fontSize: moderateScale(16),
                                        // marginEnd: moderateScale(10)
                                    }}/>

                                </View>
                            </TouchableOpacity>
                        </View>
                    </View>

            </HMModal>

        );
    }

    onDayPress(day) {
        content.setState({
                ["Date" + content.state.NameDate]: day.format('jYYYY/jM/jD'),

            }
            , () => {
                //   alert(day.dateString)
                // alert( moment(day.dateString, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD'))

            }
        );
    }

    onPressOkDate() {
        // this.props.onPressOk
        // if (content.state["Date" + content.state.NameDate]) {
        content.setState({
                // NameDate: data,
                //  finalDate: moment(content.state.Date, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD'),
                //  selectedDate: 1
                showDialogDate: null,
                [`finalDate${content.state.NameDate}`]: content.state["Date" + content.state.NameDate] ? content.state["Date" + content.state.NameDate] : moment().format("jYYYY/jMM/jDD"),
                ["selectedDate" + content.state.NameDate]: 1
            },
            () => {
                content.props.setBirthDay(content.state["Date" + content.state.NameDate] ? content.state["Date" + content.state.NameDate] : moment().format("jYYYY/jMM/jDD"))
            });
        // }
        // else {
        //     HMAlert(
        //         i18n.t('constant.message'),
        //         "تاریخی را انتخاب نگرده اید!!!",
        //         [
        //             // {text: 'Ask me later', onPress: () => {}},
        //             // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
        //             {text: 'خب', onPress: () => {}},
        //         ],
        //         {cancelable: true}
        //     )
        // }

    }

    onPressCancelDate(name) {
        if (content.state.showDialogDate === null && content.state[`finalDate` + name]) {
            content.setState({

                    showDialogDate: null,
                    ["selectedDate" + name]: 0,
                    ["Date" + name]: 0,
                    ["finalDate" + name]: 0,

                    NameDate: name,

                },
                () => {
                    this.props.cancel()
                });
        }
        else if (content.state.showDialogDate === null && !content.state[`finalDate` + name]) {
            content.setState({

                    showDialogDate: true,
                    ["selectedDate" + name]: 0,
                    ["Date" + name]: 0,
                    ["finalDate" + name]: 0,

                    NameDate: name,

                },
                () => {
                });
        }
        else if (content.state.showDialogDate !== null && content.state[`finalDate` + name]) {
            content.setState({

                    showDialogDate: null,
                    ["selectedDate" + name]: 0,
                    ["Date" + name]: 0,
                    ["finalDate" + name]: 0,

                    NameDate: name,

                },
                () => {
                    this.props.cancel()
                });
        } else
            content.setState({
                    showDialogDate: true,
                    // selectedDate: 0,
                    // Date: 0,
                    // finalDate: 0
                    NameDate: name,
                    ["selectedDate" + name]: 0,
                    ["Date" + name]: 0,
                    ["finalDate" + name]: 0
                },
                () => {
                });
    }

    onPressBackDate() {
        this.props.cancel()
        content.setState({
            showDialogDate: null
        })
    }
}


const mapStateToProps = state => {
    return {
        //  DataSplashScreen: state.reducerSplashSatiaScreen,
        //  wifiIsEnabled: state.reducerSplashSatiaScreen.wifiIsEnabled,
        // wifiConnectionStatus: state.reducerSplashSatiaScreen.wifiConnectionStatus,

    };
};
const mapDispatchToProps = dispatch => {
    return {
       // setIsConnected: (data) => dispatch(serviceActionSetIsConnected(data)),
        // callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(HMDatePicker);

const styles = StyleSheet.create({
    modalBackDrop: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',

        // height:"100%",
        // width:"100%",

        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 99999
    },
    modalDialog: {
        backgroundColor: "white",
        width: '85%',

        alignItems: 'center',
        justifyContent: 'center',
        padding: moderateScale(15),
        //    flex:1,

        // height: moderateScale(185),
        borderRadius: moderateScale(1),
        marginHorizontal: moderateScale(10),
    },
    modalLoading: {
        textAlign: "center",
    },

    modalTextTitle: {
        fontSize: moderateScale(16),
        color: 'black',
        //  fontFamily: "IRANSansMobile",
        justifyContent: 'center',
        textAlign: 'center',
        fontWeight: 'bold'
    },
    modalTextDescription: {
        fontSize: moderateScale(14),
        // fontFamily: "IRANSansMobile",
        color: 'black',
        margin: 10
    },
    modalVeiwOk: {
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',

    },
    modalTextName: {
        fontSize: moderateScale(16),
        color: 'black',
        // fontFamily: "IRANSansMobile",
        marginTop: moderateScale(6),
        marginBottom: moderateScale(6)
    },
    modalTextDesc: {
        fontSize: moderateScale(14),
        color: 'black',
        //fontFamily: "IRANSansMobile",
    },
    buttonShowStyle: {
        padding: moderateScale(10),
        width: '100%',
        marginLeft: moderateScale(6),
        borderRadius: moderateScale(4),
        marginTop: moderateScale(10)

    }, buttonCancelStyle: {
        padding: moderateScale(10),
        width: '100%',
        marginRight: moderateScale(6),
        borderRadius: moderateScale(4),
    }
});
